module.exports = __webpack_public_path__ + "static/media/chameleon.832f4cf5.svg";